module.exports = __webpack_public_path__ + "static/img/bigquery-icon.f1d60e6e.svg";